import gql from 'graphql-tag';

export const get = gql`
  query getInviteGuest($guestHash: String) {
    getInviteGuest(guestHash: $guestHash) {
      id
      hashId
      invite {
        id
        name
        start
        end
      }
      condominium {
        id
        name
        email
        phone
        treeNodeId
      }
      unityGroup {
        id
        name
      }
      unity {
        id
        name
      }
      address {
        id
        addressTypeId
        cityId
        streetName
        addressNumber
        additionalInfo
        isPrincipal
      }
      isPorterPartner
      partnerPersonContextId
      condominiumPersonContextId
      hasFaceId
      hasFacial
      hasQrCode
      qrCode
      allowFaceEdit
      accessProfileName
      customBackground
      customInvite
      customInviteName
      customBanner
      customBannerUrl
      customPorterUrl
      guestName
      hasSmartLock
    }
  }
`;

export const personalizedInvite = gql`
  query personalizedInvite($id: Int!) {
    personalizedInvite(id: $id) {
      id
      inviteTitle
      eventDate
      location {
        name
        address
        mapsUrl
      }
      destination
      customization {
        primaryColor
        secondaryColor
        logoUrl
        bannerImageUrl
      }
      hasFacialRegistered
      facialPhoto
      userName
    }
  }
`;

export const getGuestFacePhoto = gql`
  query getGuestFacePhoto($guestHash: ID!) {
    getGuestFacePhoto(guestHash: $guestHash) {
      base64Photo
      contentType
    }
  }
`;
